import React from 'react';
import { uid } from 'react-uid';
import UseCaseMediaAndText from './MediaAndText';
import UseCaseIconCards from './IconCards';
import UseCaseImageCards from './ImageCards';

const ContentBlocks = ({ blocks }) =>
  blocks.map((block) => {
    switch (block.fieldGroupName.split('_').pop()) {
      case 'MediaAndText':
        return <UseCaseMediaAndText key={uid(block)} block={block} />;
      case 'IconCards':
        return <UseCaseIconCards key={uid(block)} block={block} />;
      case 'ImageCards':
        return <UseCaseImageCards key={uid(block)} block={block} />;
      default:
        return null;
    }
  });

export default ContentBlocks;
